import * as navigation from 'Navigation';

// `versionApiId` is the version shown on the page, or undefined for the latest.
export default class ProcedureTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Procedure',
      closeable: false,
      preferenceKey: 'procedure',
    };
  }
}
